import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Link, useSearchParams } from "react-router-dom";
import AuthLayout from "../components/auth/AuthLayout";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const ConfirmEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = useMemo(() => searchParams.get("token") || "", [searchParams]);
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [message, setMessage] = useState("Confirmation en cours...");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("Lien de confirmation invalide.");
      return;
    }

    const confirmEmail = async () => {
      try {
        const response = await axios.get(`${backendUrl}/api/confirm-email`, {
          params: { token },
        });

        setStatus("success");
        setMessage(response.data?.message || "Votre compte est active.");
      } catch (error: any) {
        setStatus("error");
        setMessage(
          error?.response?.data?.message ||
            "Le lien de confirmation est invalide ou expire."
        );
      }
    };

    void confirmEmail();
  }, [token]);

  return (
    <AuthLayout>
      <div className="text-center">
        <h2
          className="mb-3"
          style={{
            color: "#111827",
            fontSize: "30px",
            fontWeight: 700,
          }}
        >
          Confirmation email
        </h2>
        <div
          className={`alert ${
            status === "success"
              ? "alert-success"
              : status === "error"
                ? "alert-danger"
                : "alert-info"
          }`}
          role="alert"
        >
          {message}
        </div>

        {status !== "loading" && (
          <Link
            to="/login"
            className="btn col-lg-12 mx-auto d-block"
            style={{
              background: "#ffc928",
              borderColor: "#ffc928",
              color: "#111827",
              borderRadius: "6px",
              fontWeight: 700,
              minHeight: "46px",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 8px 18px rgba(255, 201, 40, 0.24)",
            }}
          >
            Aller a la connexion
          </Link>
        )}
      </div>
    </AuthLayout>
  );
};

export default ConfirmEmail;
